import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import SelectableRecordTable from 'components/selectable_record_table/selectable_record_table';

import { getRequirementsSets } from './store/selectors/search';
import RequirementsSetRow from './requirements_set_row';
import RequirementsTableHeader from './table_header';

export class RequirementsSetTable extends React.Component {
  static propTypes = {
    requirementsSets: PropTypes.array.isRequired
  };

  render() {
    return (
      <SelectableRecordTable columnHeaders={<RequirementsTableHeader />} hasSelectColumn={false}>
        {this.renderRows()}
      </SelectableRecordTable>
    );
  }

  renderRows() {
    return this.props.requirementsSets.map(set => <RequirementsSetRow key={set.id} requirementsSet={set} />);
  }
}

const mapStateToProps = state => ({
  requirementsSets: getRequirementsSets(state)
});

export default connect(mapStateToProps)(RequirementsSetTable);